var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "editorProcess"
  }, [_c('div', {
    ref: "processCanvas",
    staticClass: "canvas",
    attrs: {
      "id": "editor-process-readonly"
    }
  }), _c('editorOptions', {
    attrs: {
      "diagram": _vm.diagram,
      "zoomSize": _vm.defaultZoomSize
    },
    on: {
      "update:zoomSize": function ($event) {
        _vm.defaultZoomSize = $event;
      },
      "update:zoom-size": function ($event) {
        _vm.defaultZoomSize = $event;
      }
    }
  }, [_c('div', {
    staticClass: "diagramAddOn"
  }, [_c('div', {
    staticClass: "overviewWrap",
    class: {
      on: _vm.overviewStatus
    }
  }, [_c('div', {
    staticClass: "overview",
    attrs: {
      "id": "editor-overview"
    }
  })])])]), _c('contextMenuTemplate', {
    attrs: {
      "slctType": _vm.slctType,
      "readonlyFlag": true,
      "isVisualization": true
    },
    on: {
      "contextMounted": _vm.getContext
    }
  }), _c('Loading', {
    attrs: {
      "visible": _vm.loading
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }